import React, { useEffect, useRef, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import QuestionTabs from "./LeadsTabs";
import PaginationNew from "../common/Pagination";
import api from "../../seller-apis/api";
import { fetchunansQA, fetchIgnoredQA } from "../../seller-apis/apidataField";
import SubmitAnswerModal from "../common/SubmitAnswerModal";
import { Actions } from "../../Actions/Actions";
import { useDispatch, useSelector } from "react-redux";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import { useAlert } from "react-alert";
import UnlockPopup from "./popup/UnlockPopup";
import SellerRemarkModal from "./popup/sellerRemarkModal";
import CommentHistoryModal from "./popup/CommentHistoryModal";
import Popup from "../common/Popup";
import UnlockPopupSuccess from "./popup/UnlockPopupSuccess";
import LeadForwardModal from "./popup/ForwardModal";
import EditStatusModal from "./popup/EditStatusModal";
import StatusUpdatePopup from "./popup/statusUpdatePopup";
import LeadsChatModal from "./popup/ChatModal/index.js";
import WalletPopup from "../WalletTransaction/walletPopup";
import UnlockLeadsPopup from "../WalletTransaction/UnlockLeadsPopup";
import SubscriptionView from "./SubscriptionView.js";
import { GenUtilities } from "../../utilities/GenUtilities.js";
import ProductDetConf from "../common/ProductDetConf.js";
import '../../assets/css/payment.css';//SL-710
import DropdownPortal from "../common/ReactPortal.js";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import ConfirmationModal from "../common/ConfirmationModal";
import MainLoader from "../common/Loader/PageLoader.js";

var filterData = {
   pageNo: 1,
  size: 12,
  vendorFilter: {
    //status: { $ne: "LOCKED" },
  },
};
var dateFromWeb;
var dateToWeb;
function LeadList(props) {
  const dispatch = useDispatch();
  const [leads, setLeads] = useState([]);
  const [totalrecords, setTotalRecords] = useState();
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedData, setSelectedData] = useState(null);
  const [showUnlock, setShowUnlock] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [leadIndex, setLeadIndex] = useState(0);
  const [sku, setSKU] = useState("");
  const [leadStatus, setLeadStatus] = useState("");
  const [comment, setComment] = useState("");
  const [leadId, setLeadId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [isDetailPopupVis, setisDetailPopupVis] = useState(false);
  const [showForwardModal, setShowForwardModal] = useState(false);
  const [showEditStatusModal, setShowEditStatusModal] = useState(false);
  const [productDetail, setproductDetail] = useState([]);
  const [leadsComments, setLeadsComments] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [statusObject, setStatusObject] = useState({});
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [statusToBeUpdated, setStatusToBeUpdated] = useState("");
  const [sortdatefrom, setsortdatefrom] = useState("");
  const [sortdateto, setsortdateto] = useState("");
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(false);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [customerSearchType, setCustomerSearchType] = useState("phone");
  const [customerSearchTypeDropDown, setCustomerSearchTypeDropDown] =
    useState(false);
  const [productSearchTypeDropDown, setProductSearchTypeDropDown] =
    useState(false);
  const [productSearchTerm, setproductSearchTerm] = useState("SKU");
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null);
  //Sl-710
  const [showUnlockSuccess, setShowUnlockSuccess] = useState(false);
  const [showWalletPopup, setShowWalletPopup] = useState(false);
  const [showUnlockLeadsPopup, setShowUnlockLeadsPopup] = useState(false);
  const alert = useAlert();
  const statusArray = [
    "OPEN",
    "FOLLOW_UP",
    "FORWARDED",
    "CONVERTED",
    "NOT_RELEVANT",
    "NOT_INTERESTED",
    "NO_RESPONSE",
  ];
  //SL-710 Leads
  const [subscriptionDetail, setSubscriptionDetails] = useState({});
  const [selectDropOpen, setSelectDropOpen] = useState(false);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const [ennewloader, setennewloader] = useState("block");
  var outerdiv;
  var loaderDiv;
  var currentDate = new Date();

  // Get the date before 15 days
  var dates = GenUtilities.getDateRange(15);

  // Format the dates as strings (optional)
  var currentDateStr = dates[1];
  var before15DaysStr = dates[0];

  //Sl-710
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [confirmationState, setconfirmationState] = useState(false);
  const [msgConfirmation, setmsgConfirmation] = useState();

  const toggleDropdown = (index) => {
    setLeadIndex(index);
    setDropdownOpen(!isDropdownOpen);
  };

  const handleUnlockClose = () => {
    setShowUnlock(false);
  };
  const handleCloseForwardModal = () => {
    setShowForwardModal(false);
  };
  // const closeDropdown = (event) => {
  //   // Close the dropdown if the click is outside the dropdown
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setDropdownOpen(false);
  //   }
  // };

  // useEffect(() => {
  //   // Attach the event listener when the component mounts
  //   document.addEventListener('click', closeDropdown);

  //   // Clean up the event listener when the component unmounts
  //   return () => {
  //     document.removeEventListener('click', closeDropdown);
  //   };
  // }, []);
  useEffect(() => {
    getLeads(filterData);
      }, []);

  const productDetails = (data) => {
    setisDetailPopupVis(true);
    setproductDetail([data]);
  };

  const setpopupVisibilityDetail = () => {
    setisDetailPopupVis(false);
  };

  const updateSatus = (leadId, status, statusText = "") => {
    let param = {
      _id: leadId,
      status: status,
      statusText: statusText,
    };

    api.customerLeads
      .updateStatus(param)
      .then((data) => {
        setDropdownOpen(false);
        setShowUnlock(false);
        setShowForwardModal(false);
        setShowConfirmPopup(false);
        setShowEditStatusModal(false);
        /*if (leads[selectedIndex]?.vendorDetails?.vendors[0]) {
          leads[selectedIndex].vendorDetails.vendors[0].status = status;
        }
        setLeads([...leads])*/
        getLeads();
      })
      .catch((error) => {
        alert.info(error?.response?.data?.message || 'Something went wrong');
        console.log(error);
      });
  };

  function getLeads(data = filterData) {
    // usedLeads = 0;
    applyLoader();
    //data[" pageNo"] = selectedPage;
    api.customerLeads.getLeads(data).then((res) => {
      removeLoader();
      setLeads(res.data.records);
      setTotalRecords(res.data.totalRecords);
    });
    //SL-710
    api.customerLeads.getSubscriptionDetails().then((data) => {
      console.log('data',data)
      setSubscriptionDetails(data);
      Actions.LeadSubscriptionDetail(dispatch, data);//SL-710
    });

  }

  function paginate(data) {
    let param = {
      vendorFilter: { ...filterData.vendorFilter },
      pageNo: data.number,
      size: 12,
    };
    getLeads(param);
    setSelectedPage(data.number);
  }
  const handleConfirm = () => { };
  const handleCloseModal = () => {
    setShowModal(false);
    setShowCommentModal(false);
    getLeads();
  };
  const applyFilter = (data, type) => {
    let apiCall = true;
    setSelectedPage(1);
    let filterData1 = filterData;
    console.log('filterData1', filterData1)
    console.log("customerSearchTerm ",customerSearchTerm)
    switch (type) {
      case "status":
        if (data == "all") {
          filterData1["vendorFilter"] = {};
        }
        else {
          filterData1["vendorFilter"] = {
            //status: data,
            status: {$in : data}
          };
        }
        break;

      case "SKU":
        filterData1["filter"] = { "productDetails.SKU": data };
        break;
      case "Product":
        filterData1["filter"] = { "productDetails.name": data };
        break;

      case "comment":
        filterData1["vendorFilter"] = {
          ...filterData1.vendorFilter,
          "comment.desc": data,
        };
        break;
      case "reqDate":
        if (sortdatefrom != "" && sortdateto != "") {
          delete filterData1.vendorFilter["from-unlockedDate"];
          delete filterData1.vendorFilter["to-unlockedDate"];
          filterData1["filter"] = {
            "from-createdAt": sortdatefrom + "T00:00:00",
            "to-createdAt": sortdateto + "T23:59:59",
          };
        }
        else {
          apiCall = false;
          alert.info("Please select a valid date range.")
        }


        break;
      case "unlockDate":
        if (sortdatefrom != "" && sortdateto != "") {
          delete filterData1.filter["from-createdAt"];
          delete filterData1.filter["to-createdAt"];
          filterData1["vendorFilter"] = {
            ...filterData1.vendorFilter,
            "from-unlockedDate": sortdatefrom + "T00:00:00",
            "to-unlockedDate": sortdateto + "T23:59:59",
          };
        }
        else {
          apiCall = false;
          alert.info("Please select a valid date range.")
        }

        break;
      case "phone":
        if(customerSearchTerm != ""){
          filterData1["filter"] = {
            phone: customerSearchTerm,
          };
          //SL-701
          filterData1["vendorFilter"] = {
            status: {$nin : ["LOCKED"]}
          };
        }
        else{
          delete filterData1.filter["phone"];
          delete filterData1.vendorFilter["status"];
        }
       
        break;
      case "email":
        if(customerSearchTerm != ""){
          filterData1["filter"] = {
            email: customerSearchTerm,
          };
          //SL-701
          filterData1["vendorFilter"] = {
            status: {$nin : ["LOCKED"]}
          };
        }
        else{
          delete filterData1.filter["email"];
          delete filterData1.vendorFilter["status"];
        }
        break;

      // Add more cases as needed

      default:
        // Handle the default case, if necessary
        break;
    }
    if (apiCall)
      getLeads(filterData1);
  };

  function setdateweb(e, type) {
    setFilterButtonDisabled(false);
    dateFromWeb = sortdatefrom;
    dateToWeb = sortdateto;
    if (type === "from") {
      dateFromWeb = e.target.value;
      setsortdatefrom(dateFromWeb);
    } else {
      dateToWeb = e.target.value;
      setsortdateto(e.target.value);
    }

    // console.log(dateFromWeb,dateToWeb);
    // if (dateFromWeb != undefined && dateToWeb != undefined) {
    //   setsortdatefrom(dateFromWeb);
    //   setsortdateto(dateToWeb);
    //   let fromDate = new Date(dateFromWeb)
    //   let toDate = new Date(dateToWeb);
    //   let diffDate = toDate.getTime() - fromDate.getTime()
    //   let daydiffer = diffDate / (1000 * 60 * 60 * 24);
    //   daydiffer = Math.floor(daydiffer)
    //   console.log(daydiffer)
    //   if (daydiffer > 30) {
    //     setFilterButtonDisabled(true);
    //     alert.info('Date range cannot be more than 30 days.', { position: 'top center' })
    //   }
    //   else if (daydiffer < 0) {
    //     setFilterButtonDisabled(true);
    //     alert.info("Please select a valid date range.")
    //   }
    // }
  }
  //<Start-Here> Seller Leads Ticket: SL-710
  /**
 * Check available Leads based on Price or special Price
 */
  let usedLeads = 0;
  function checkAvailableLeads() {
    const {leads, isSubscribed} = subscriptionDetail;
    //if available leads <= 0 return false
    // else if leads > 0 check usedLeads < leads return true (to show free leads button) 
    //else return false to show view contact  
    if(leads > 0 && usedLeads < leads){
      usedLeads++;
      return true;
    }
    else
      return false;
    //need to display the available free leads with yellow button unlock free lead only after view contacts
    /*if(!isSubscribed){
      //if available leads <= 0 retrun false
      // else if leads > 0 check usedLeads < leads retrun true (to show free leads button) 
      //else return false to show view contact  
      if(leads > 0 && usedLeads < leads){
        usedLeads++;
        return true;
      }
      else
        return false;
      
    }
    else //If subscribed check available leads > 0
      return (leads > 0); */
  }
  
  /**
   * Update Lead Status
   * @param {*} leadId 
   * @param {*} status 
   */
  const updateLeadSatus = (leadId, status,markDelete = false) => {
    let param = {
      _id: leadId,
      status: status,
    };
    if(markDelete)
      param['markDelete'] = markDelete;
    api.customerLeads
      .updateStatus(param)
      .then((data) => {
        status === "OPEN" && setShowUnlockSuccess(true);
        setShowUnlock(false);
        if(confirmationState)//SL-710
          setconfirmationState(false);
        getLeads();
      })
      .catch((error) => {
        if(confirmationState)//SL-710
          setconfirmationState(false);
        console.log(error);
      });
  };
  /**
   * Handle Unlock Success Popup Close
   */
  const handleUnlockSuccessClose = () => {
    setShowUnlockSuccess(false);
  };
  /**
   * Handle Wallet Popup Close
   */
  function handleWalletClose() {
    setShowWalletPopup(false);
  }

  function handleUnlockLeadsClose() { 
    getLeads();
    setShowUnlockLeadsPopup(false);
  }

  const handleStatusCheckboxChange = (value, checked) => {
    let updatedStatuses = [...selectedStatuses];

    if (checked) {
      updatedStatuses.push(value);
    } else {
      updatedStatuses = updatedStatuses.filter((status) => status !== value);
    }

    setSelectedStatuses(updatedStatuses);
    applyFilter(updatedStatuses, "status");
  };

  // Confirmation Modal
  function notRelevantLead(e) {
    setSelectedLeadId(e._id);
    setSelectedData(e);
    setmsgConfirmation("Do you want to mark this lead as not relevant?");
    setconfirmationState(true);
  }

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false);
    }
  }
   // Confirmation Response
   function responseConfirmationEnquiry(response, id) {
    
      if (response === "yes") {
         updateLeadSatus(selectedLeadId,"NOT_RELEVANT",true)
      }
    
  }
  /**
   * Show loader
   */
  function applyLoader() {
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
  }

  /**
   * remove loader
   */
  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none")
  }
  //</End-Here> Seller Leads Ticket: SL-710
  return (
    <>
      <div className="" id="orDeskContain">
      <div className="row mb-4 py-2 border-bottom-1">
        <div className="col-md-9"></div>
        <div className="col-md-3 text-right dis-flex">
          {/* <SubscriptionView /> */}
        </div>
      </div>
      <div className="question-container">
        <div className="theme-shed1 p-2">
          <div className="m-auto mt-1">
            <span className="payment_dates">
              From: -{" "}
              <input
                type="date"
                value={sortdatefrom}
                onChange={(e) => setdateweb(e, "from")}
              ></input>
            </span>
            <span className="mx-2 payment_dates">
              To: -{" "}
              <input
                type="date"
                value={sortdateto}
                onChange={(e) => setdateweb(e, "to")}
              ></input>
            </span>
            <div class="dropdown">
              <span>
                <div
                  disabled={filterButtonDisabled}
                  //onClick={() => setShowDateDropdown(!showDateDropdown)}
                  className="apply-btn px-3 py-1 ff_Pop fs-14 pointer"
                  onClick={() => applyFilter("", "reqDate")}
                >
                  Apply
                </div>
              </span>
              {/*showDateDropdown ? (
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  style={{ display: "block" }}
                >
                  <a
                    class="dropdown-item"
                    onClick={() => {
                      setShowDateDropdown(!showDateDropdown);
                      applyFilter("", "reqDate");
                    }}
                    href="#"
                  >
                    Search by Requested Date
                  </a>
                  <a
                    class="dropdown-item"
                    onClick={() => {
                      setShowDateDropdown(!showDateDropdown);
                      applyFilter("", "unlockDate");
                    }}
                    href="#"
                  >
                    Search by Unlocked Date
                  </a>
                </div>
              ) : (
                ""
              )*/}
            </div>
            <NavLink
              exact
              to="/wallet-transaction/vendor-transaction"
              className="apply-btn px-3 py-1 ff_Pop fs-12 pointer txDetails"
            >
              <p>Transaction Details</p>
            </NavLink>

          </div>
        </div>
        <div className="table-responsive">
          <table className="w-100 new-table-design pt-2 leads_list_table">
            <tr>
              <th style={{ width: "10%" }}>Received Date</th>
              <th style={{ width: "20%" }}>
                Customer Details
                <div class="input-group">
                  <div class="dropdown">
                    <button
                      type="button"
                      onClick={() =>
                        setCustomerSearchTypeDropDown(!customerSearchTypeDropDown)
                      }
                      class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split m-0 h-30"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {customerSearchType == "phone" ? (
                        <i class="fa fa-phone" aria-hidden="true"></i>
                      ) : (
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                      )}
                    </button>
                    {customerSearchTypeDropDown ? (
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                        style={{ display: "block" }}
                      >
                        <a
                          class="dropdown-item"
                          onClick={() => {
                            setCustomerSearchTypeDropDown(false);
                            setCustomerSearchType("phone");
                          }}
                          href="#"
                        >
                          <i class="fa fa-phone" aria-hidden="true"></i> Phone
                        </a>
                        <a
                          class="dropdown-item"
                          onClick={() => {
                            setCustomerSearchTypeDropDown(false);
                            setCustomerSearchType("email");
                          }}
                          href="#"
                        >
                          <i class="fa fa-envelope" aria-hidden="true"></i> Email
                        </a>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <input
                    type="text"
                    class="form-control m-0 h-30 fs-12"
                    onChange={(e) => setCustomerSearchTerm(e.target.value)}
                    placeholder={`Enter ${customerSearchType}`}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                  />
                  <div
                    class="input-group-append"
                    onClick={(e) => {
                      applyFilter(customerSearchTerm, customerSearchType);
                    }}
                  >
                    <span class="input-group-text" id="basic-addon2">
                      <i class="fa fa-search pointer" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </th>
              <th style={{ width: "10%" }}>Product Image</th>
              <th style={{ width: "20%" }}>
                Product Details
                <div class="input-group">
                  <div class="dropdown">
                    <button
                      type="button"
                      onClick={() =>
                        setProductSearchTypeDropDown(!productSearchTypeDropDown)
                      }
                      class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split m-0 h-30"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {productSearchTerm == "SKU" ? (
                        <i class="fa fa-file-text" aria-hidden="true"></i>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" height="15"><path d="M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z" /></svg>
                      )}
                    </button>
                    {productSearchTypeDropDown ? (
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                        style={{ display: "block" }}
                      >
                        <a
                          class="dropdown-item"
                          onClick={() => {
                            setSKU("");
                            setProductSearchTypeDropDown(false);
                            setproductSearchTerm("SKU");
                          }}
                          href="#"
                        >
                          <i class="fa fa-file-text" aria-hidden="true"></i> SKU
                        </a>
                        <a
                          class="dropdown-item"
                          onClick={() => {
                            setSKU("");
                            setProductSearchTypeDropDown(false);
                            setproductSearchTerm("Product");
                          }}
                          href="#"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="15" height="15"><path d="M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z" /></svg> Product
                        </a>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <input
                    type="text"
                    class="form-control m-0 h-30 fs-12"
                    value={sku}
                    onChange={(e) => setSKU(e.target.value)}
                    placeholder={`Enter ${productSearchTerm}`}
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                  />
                  <div
                    class="input-group-append"
                    onClick={(e) => {
                      applyFilter(sku, productSearchTerm);
                    }}
                  >
                    <span class="input-group-text" id="basic-addon2">
                      <i class="fa fa-search pointer" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </th>

              <th style={{ width: "15%" }}>Remark</th>

              {/* SL-710 */}
              <th style={{ position: "relative" }}>
                Status
                <br />
                <div className="dropdown-wrapper">
                  <button
                    className="form-control form-select fs-12 h-30"
                    onClick={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      setDropdownPosition({
                        top: rect.bottom + window.scrollY,
                        left: rect.left + window.scrollX,
                        width: rect.width,
                      });
                      setSelectDropOpen(!selectDropOpen)
                    }}
                  >
                    {selectedStatuses.length === 0
                      ? "All"
                      : `${selectedStatuses.length} selected`}
                  </button>

                  {selectDropOpen && (
                    <DropdownPortal>
                      <div className="dropdown-checkbox-menu" style={{
                        position: "absolute",
                        top: dropdownPosition.top,
                        left: dropdownPosition.left,
                        width: dropdownPosition.width,
                        zIndex: 9999,
                        background: "white",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        padding: "10px",
                        maxHeight: "250px",
                        overflowY: "auto",
                      }}>
                        <div className="form-check form_check_lead_list">
                          <input
                            type="checkbox"
                            className="form-check-input w-8"
                            id="status-all"
                            checked={selectedStatuses.length === 0}
                            onChange={() => {
                              setSelectedStatuses([]);
                              applyFilter([], "status");
                            }}
                          />
                          <label htmlFor="status-all" className="w-70">All</label>
                        </div>

                        {statusArray.map((item, index) => (
                          <div className="form-check form_check_lead_list" key={index}>
                            <input
                              className="form-check-input w-8"
                              type="checkbox"
                              value={item}
                              id={`status-${index}`}
                              checked={selectedStatuses.includes(item)}
                              onChange={(e) => handleStatusCheckboxChange(e.target.value, e.target.checked)}
                            />
                            <label className="form-check-label w-70" htmlFor={`status-${index}`}>
                              {item.replace("_", " ")}
                            </label>
                          </div>
                        ))}
                      </div>
                    </DropdownPortal>
                  )}
                </div>
              </th>
              {/* SL-710 */}

              <th style={{ width: "15%" }}>Action</th>
            </tr>
            {leads.length > 0 &&
              leads.map((item, index) => {
                // let baseImg = "";
                // item.productId.images.map((item) => {
                //   if (item.baseImage === true) {
                //     if (item.image.startsWith("products")) {
                //       baseImg = item.image;
                //     } else {
                //       let img = item.image.substr("41");
                //       baseImg = img;
                //     }
                //   }
                // });
                return (

                  <tr>
                    <td>
                      <div className="border-x">
                        <div className="lead-date">
                          {formatedDate(item.createdAt)}
                        </div>
                        {/*<div className="lead-date">
                          <div className="date-title tv-color text-left">
                            Unlock Date
                          </div>
                          {formatedDate(
                            item?.vendorDetails?.vendors[0]?.unlockedDate
                          )}
                          </div>*/}
                      </div>
                    </td>
                    <td>
                      <div className=" text-left border-x px-2">
                        <div className="product-name text-left w-100 mt-1">
                          <>
                            <div>{item?.name}</div>
                            {/* <div>
                              {item.state}, {item.pincode}
                            </div> */}

                            <div>
                              {item?.vendorDetails?.vendors[0]?.status !=
                                "LOCKED" ? (
                                item.phone
                              ) : (
                                <div className="blur-phone">0000000000</div>
                              )}
                            </div>
                            <div>{item?.email}</div>
                            <div>Price: ₹{item.product.specialPrice != undefined ? item.product.specialPrice : item.product.price}</div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" stroke="#666" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span>{(item?.city ?? 'N/A') + ', ' + (item?.state ?? 'N/A')}</span>
                              </div>

                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 6V12L15 14" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                  <circle cx="12" cy="12" r="9" stroke="#666" strokeWidth="1.5"/>
                                </svg>
                                <span>{item?.time ?? 'N/A'}</span>
                              </div>
                              
                            {/* Remark (item?.vendorDetails?.vendors[0]?.status != "LOCKED") */}
                              {<OverlayTrigger
                                    key="remark"
                                    placement="left"
                                    overlay={
                                      <Tooltip id={'tooltip-remark'} className="fs-16">
                                        <p className='fs-10 f-500'> {item?.remark}</p>
                                      </Tooltip>
                                    }
                                  >
                                    <div className="mb-1 truncate-two-lines">
                                      <span className="fs-11">Remark : </span>{" "}
                                      <span className="fs-10 bold">{item?.remark}</span>{" "}
                                    </div>
                              </OverlayTrigger>}
                            
                            {
                              item?.vendorDetails?.vendors[0]?.status == "LOCKED" ?
                                <>
                                  {checkAvailableLeads() ? (
                                    <button
                                      className="unlock_free_leads"
                                      onClick={() => {
                                        //setStatusObject({ "title": ``, "subTitle": "Are you sure want to unlock this lead?" });
                                        setStatusToBeUpdated("OPEN");
                                        setSelectedPrice(item?.leadPrice);
                                        setSelectedLeadId(item._id);
                                        //setShowUnlock(true);
                                        setSelectedIndex(index)
                                        updateSatus(item._id,"OPEN")
                                      }}
                                    >
                                      <img src="/unlock.png" />Unlock Free Lead
                                    </button>

                                  ) : (
                                  <button
                                    className="apply-btn px-3 py-1 ff_Pop fs-12 pointer"
                                    style={{ marginTop: "5px" }}
                                    onClick={() => {
                                      // setStatusToBeUpdated("OPEN");
                                      setShowUnlockLeadsPopup(true);
                                      // setSelectedPrice(item?.leadPrice);
                                      setSelectedLeadId(item._id);
                                      // setSelectedIndex(index)
                                      // updateSatus(item._id,"OPEN")
                                    }}
                                  >
                                    <i class="bi bi-lock"></i> Unlock Lead
                                  </button>
                                )}
                                </> : <></>
                            }

                            {/* {
                              item?.vendorDetails?.vendors[0]?.status == "LOCKED" ?
                                <>
                                  {subscriptionDetail.isSubscribed ? (
                                    <>
                                      <button
                                        className="apply-btn px-3 py-1 ff_Pop fs-12 pointer"
                                        style={{ marginTop: "5px" }}
                                        onClick={() => {
                                          //setStatusObject({ "title": ``, "subTitle": "Are you sure want to unlock this lead?" });
                                          setStatusToBeUpdated("OPEN");
                                          setSelectedPrice(item?.leadPrice);
                                          setSelectedLeadId(item._id);
                                          //setShowUnlock(true);
                                          setSelectedIndex(index)
                                          updateSatus(item._id,"OPEN")
                                        }}
                                      >
                                        View Contact
                                      </button>
                                      <br />
                                    </>
                                  ) : (
                                    <>
                                      {checkAvailableLeads() ? (
                                        <button
                                          className="unlock_free_leads"
                                          onClick={() => {
                                            //setStatusObject({ "title": ``, "subTitle": "Are you sure want to unlock this lead?" });
                                            setStatusToBeUpdated("OPEN");
                                            setSelectedPrice(item?.leadPrice);
                                            setSelectedLeadId(item._id);
                                            //setShowUnlock(true);
                                            setSelectedIndex(index)
                                            updateSatus(item._id,"OPEN")
                                          }}
                                        >
                                          <img src="/unlock.png" />Unlock Free Lead
                                        </button>

                                      ) : (hoveredRowIndex === index ? (
                                        <button
                                          className="subscribe_to_view"
                                          onClick={() => setShowWalletPopup(true)}
                                          onMouseLeave={() => setHoveredRowIndex(null)}
                                        >
                                          <i class="bi bi-info-circle-fill text-warning" ></i>
                                          Subscribe to View <br />Contact Details
                                        </button>
                                      ) : (
                                        <button
                                          className="apply-btn px-3 py-1 ff_Pop fs-12 pointer"
                                          style={{ marginTop: "5px" }}
                                          onMouseEnter={() => setHoveredRowIndex(index)} // Show tooltip button on hover
                                        >
                                          View Contact
                                        </button>
                                      )
                                      )
                                      }
                                      <br />
                                    </>
                                  )}
                                </>
                                : <></>
                            } */}


                             
                           

                          </>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="border-x">
                        <img
                          className="product-img"
                          src={`https://s3.toolsvilla.com/${GenUtilities.getBaseImage(item?.product?.image)}`}
                        />
                      </div>
                    </td>
                    <td>
                      <div className=" text-left border-x px-2">
                        <div className="product-name text-left w-100 mt-1">
                          {item?.product.productName}
                        </div>
                        <div className="question-sku-but">
                          <div
                            className="prod-sku w-100 cursor-pointer"
                            onClick={() => productDetails(item?.product)}
                          >
                            <a href="#popupDetail" className="prod-sku">
                              SKU : {item?.product.SKU}
                            </a>
                          </div>
                        </div>
                        {/* <div className="product-name text-left w-100 mt-1">
                          Quantity : {item?.quantity}
                        </div> */}
                      </div>
                    </td>
                    {/* <td>
                      <div className="border-x">
                        &#8377; {item?.product?.expectedPrice}
                      </div>
                    </td> */}
                    <td>
                      <div className="border-x relative">
                        <div className="mb-1">
                          {item?.vendorDetails?.vendors[0]?.comment.length > 0 ? (
                            <div className="dis-flex">
                              <OverlayTrigger
                                  key="sellerRemark"
                                  placement="left"
                                  overlay={
                                    <Tooltip id={'tooltip-sellerRemark'} className="fs-16">
                                      <p className='fs-10 f-500'> {item?.vendorDetails?.vendors[0]?.comment[
                                              item?.vendorDetails?.vendors[0]?.comment
                                                ?.length - 1
                                            ]?.desc}</p>
                                    </Tooltip>
                                  }
                                >
                                      <div >
                                        <div className="truncate-eight-lines" style={{
                                              fontSize: "8px",
                                              color: "#000",
                                              textAlign: "left",
                                              maxWidth: "200px"  //Constrain width
                                        }}>
                                          {
                                            item?.vendorDetails?.vendors[0]?.comment[
                                              item?.vendorDetails?.vendors[0]?.comment
                                                ?.length - 1
                                            ]?.desc
                                          }
                                        </div>
                                      </div>
                                </OverlayTrigger>
                        
                              <div
                                onClick={() => {
                                  setLeadsComments(
                                    item?.vendorDetails?.vendors[0]?.comment
                                  );
                                  setShowCommentModal(true);
                                }}
                              >
                                <img
                                  src="/info-icon.webp"
                                  class="vendor-his-icon cursor-pointer"
                                  style={{ width: "18px", height: "18px" }}
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {(item?.vendorDetails?.vendors[0]?.status != "LOCKED") &&
                              <div className="tooltip-container lead-action" style={{ marginTop: "5px", cursor: "pointer" }}>
                                  <img
                                    src="/leads-icon/remark.png"
                                    onClick={() => {
                                      setShowModal(true);
                                      setLeadId(item._id);
                                    }}
                                  />
                                  <div className="tooltip-title">Add Remark</div>
                              </div>
                              
                            }
                      </div>
                    </td>
                    <td>
                      <div className="border-x">
                        <div className="dis-flex lead-status">
                          <div className="dropdown-header" style={{ cursor: "default" }}>
                            {item?.vendorDetails?.vendors[0]?.status.replace(
                              "_",
                              " "
                            )}
                          </div>
                          
                          {(item?.vendorDetails?.vendors[0]?.status != "LOCKED") && <div
                                  className="img tooltip-container"
                                  onClick={() => {
                                    setSelectedLeadId(item._id);
                                    setShowEditStatusModal(true);
                                    setSelectedIndex(index)
                                  }}
                                >
                                  <img style={{ cursor: "pointer" }} src="/leads-icon/edit.png" />
                                  <div className="tooltip-title">Change status</div>
                            </div>
                          }
                          {(item?.vendorDetails?.vendors[0]?.status == "LOCKED") && <div
                                  className="img tooltip-container"
                                  onClick={() => {
                                    notRelevantLead(item);
                                  }}
                              >
                                  <img style={{ cursor: "pointer", width: "40px"}} src="/delete-light.webp" />
                                  <div className="tooltip-title">Not Relevant</div>
                            </div>
                          }
                          
                         
                        </div>
                        <div className="text-center w-100 px-2">
                          {item?.vendorDetails?.vendors[0]?.statusText}
                        </div>
                      </div>
                    </td>
                    <td>

                      <div className={`border-x`}>
                        {(item?.vendorDetails?.vendors[0]?.status != "LOCKED") ?
                          <>
                            <div className=" dis-flex flex-diection-row lead-action ">
                              <div className="tooltip-container">
                                <a
                                  href={`https://api.whatsapp.com/send/?phone=${item?.phone}&text=Hello ${item?.name},%0AYou just inquired about a ${encodeURI(
                                    item?.product.productName
                                  )} http://toolsvilla.com/${item?.product?.urlKey} on Toolsvilla. We appreciate your interest and look forward to assist you🤝. We are one of the verified Toolsvilla sellers %26 will soon reach out to you with further details %26 pricing of the product.`}
                                  target="_blank"
                                >
                                  <img src="/leads-icon/wa.png" />
                                </a>
                                <div className="tooltip-title">Whatsapp buyer</div>
                              </div>
                              <div className="tooltip-container">
                                <a
                                  href={`http://mail.google.com?view=cm&fs=1&to=${item?.email}&su=Leads enquiry received!&body=Dear ${item?.name},%0A%0AWe appreciate your interest in our product ${encodeURI(
                                    item?.product.productName
                                  )}, and we are here to inform you that we've received your product enquiry.%0A%0AThe enquiry details are as follows:%0A%0AProduct Name: ${encodeURI(
                                    item?.product.productName
                                  )},%0AEmail   : ${item?.email
                                    }%0APhone   : ${item?.phone}%0A%0AWe are eagerly waiting to connect and explore how we can assist you better. Looking forward to our conversation!%0A%0ABest Regards,%0AToolsvilla`}//${item?.vendorDetails?.vendors[0]?.name}%0A${localStorage.getItem('phone')}`}
                                  target="_blank"
                                >
                                  <img src="/leads-icon/mail.png" />
                                </a>
                                <div className="tooltip-title">Email buyer</div>
                              </div>

                              <div className="tooltip-container">
                                <img
                                  src="/leads-icon/forward.png"
                                  onClick={() => {
                                    setShowForwardModal(true);
                                    setSelectedLead(item);
                                    setSelectedLeadId(item._id);
                                  }}
                                />
                                <div className="tooltip-title">Share</div>
                              </div>
                            </div>
                          </> :
                          <>
                            <div className=" dis-flex flex-diection-row lead-action ">
                              <div className="tooltip-container">
                                <a

                                  href="#"
                                >
                                  <img src="/leads-icon/wa.png" className="blurred-img" />
                                </a>
                                <div className="tooltip-title">Whatsapp buyer</div>
                              </div>
                              <div className="tooltip-container">
                                <a
                                  className="blurred-img"
                                  href="#"
                                >
                                  <img src="/leads-icon/mail.png" className="blurred-img" />
                                </a>
                                <div className="tooltip-title">Email buyer</div>
                              </div>

                              <div className="tooltip-container">
                                <img
                                  src="/leads-icon/forward.png"
                                  onClick={() => {

                                  }}
                                  className="blurred-img"
                                />
                                <div className="tooltip-title">Share</div>
                              </div>
                            </div>
                          </>
                        }
                        {/* <div className=" dis-flex flex-diection-row justify-content-start lead-action w-100 px-2 mt-2">
                          <div className="tooltip-container">
                            <img
                              src="/leads-icon/forward.png"
                              onClick={() => {
                                setShowForwardModal(true);
                                setSelectedLead(item);
                                setSelectedLeadId(item._id);
                              }}
                            />
                            <div className="tooltip-title">Share</div>
                          </div>
                        </div> */}

                      </div>
                    </td>
                  </tr>

                );
              })}
            {leads.length == 0 && (
              <tr>
                <td colSpan={99}>
                  <div className="text-center">No results found</div>
                </td>
              </tr>
            )}
          </table>
        </div>

        <div class="d-flex justify-content-center" id="enNewLoader" >
            <div style={{ "display": ennewloader }}>
              <MainLoader/>
            </div>
        </div>
        <PaginationNew
          number={totalrecords}
          paginate={paginate}
          activ={selectedPage}
          comp={"details"}
          size={filterData?.size}
        />
      </div>
      {/* <Start-Here> Seller Leads SL-710 */}
      <StatusUpdatePopup
        show={showUnlock}
        handleUnlockClose={handleUnlockClose}
        updateSatus={updateLeadSatus}
        status={statusToBeUpdated}
        statusObject={statusObject}
        leadId={selectedLeadId}
        selectedPrice={selectedPrice}
      />
      <UnlockPopupSuccess
        show={showUnlockSuccess}
        handleUnlockClose={handleUnlockSuccessClose}
      />
      <WalletPopup
        show={showWalletPopup}
        handleClose={handleWalletClose}
      />
      {/* unlock leads feature Sl-3133 */}
      <UnlockLeadsPopup
        show={showUnlockLeadsPopup}
        handleClose={handleUnlockLeadsClose}
        leadId={selectedLeadId}
      />
      {/* </End-Here> Seller Leads SL-710 */}
      <SellerRemarkModal
        show={showModal}
        leadId={leadId}
        handleConfirm={handleConfirm}
        handleClose={handleCloseModal}
      />
      <CommentHistoryModal
        show={showCommentModal}
        handleClose={handleCloseModal}
        comments={leadsComments}
      />
      <LeadForwardModal
        show={showForwardModal}
        handleClose={handleCloseForwardModal}
        leadId={selectedLeadId}
        item={selectedLead}
        updateSatus={updateSatus}
      />
      <EditStatusModal
        show={showEditStatusModal}
        updateSatus={updateSatus}
        leadId={selectedLeadId}
        handleUnlockClose={() => setShowEditStatusModal(false)}
      />
      <StatusUpdatePopup
        show={showConfirmPopup}
        handleUnlockClose={() => setShowConfirmPopup(false)}
        updateSatus={updateSatus}
        status={statusToBeUpdated}
        statusObject={statusObject}
        leadId={selectedLeadId}
        selectedPrice={selectedPrice}
      />
      <LeadsChatModal
        show={showChatModal}
        selectedLead={selectedLead}
        handleClose={() => setShowChatModal(false)}
        channelId={""}
        ticket={[]}
      />
      {isDetailPopupVis && (
        <div id="popupDetail" className="overlay" style={{ display: "block" }}>
          <Popup
            from="newOrder"
            description={productDetail[0].desc}
            sdescription={productDetail[0].sDesc}
            descriptionNew={productDetail[0]?.descriptionNew || []}
            specificationNew={productDetail[0]?.specificationNew || []}
            name={productDetail[0].productName}
            // price={detailPPrice}
            SKU={productDetail[0].SKU}
            popupVisibility={setpopupVisibilityDetail}
            images={productDetail[0].image}
            videos={productDetail[0].video}
          />
        </div>
      )}
      {/*SL-710 */}
      {/* Confirmation Modal */}
      <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ConfirmationModal
            onHide={confirmationBoxHiding}
            selectedId={selectedLeadId}
            msg={msgConfirmation}
            responseconfirmationFun={responseConfirmationEnquiry}
          />
        </Modal>
      </div>
    </>
  );
}

export default LeadList;
